var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "update-share-assessment",
        title:
          _vm._.get(_vm.shareRecord, "sassessment.id") +
          " shared with " +
          _vm._.get(_vm.shareRecord, "sgroup.groupName"),
        "header-bg-variant": "success",
        "header-text-variant": "light",
        size: "lg",
        visible: _vm.showModal,
        centered: ""
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header-close",
          fn: function() {
            return [_c("h4", [_vm._v("X")])]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("br"),
            _vm._v(" "),
            _c("b", [_vm._v("Created At: ")]),
            _vm._v(" " + _vm._s(_vm.getCreatedAt()) + "\n      "),
            _c("br"),
            _vm._v(" "),
            _c("b", [_vm._v("Last Updated: ")]),
            _vm._v(" " + _vm._s(_vm.getLastUpdateDate()) + "\n      "),
            _c("br"),
            _vm._v(" "),
            _c("b", [_vm._v("Current Status: ")]),
            _vm._v(
              " " +
                _vm._s(
                  _vm._.get(_vm.shareRecord, "assessmentShareStatus", false)
                    ? "Shared"
                    : "Not Shared"
                ) +
                "\n      "
            ),
            _c("br")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "w-100",
        attrs: { slot: "modal-footer" },
        slot: "modal-footer"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b218395", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b218395","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share/UpdateShareAssessmentModal.vue
// module id = 1648
// module chunks = 0